var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _rect, _polygon2, _polygon3, _text, _line, _text2, _circle, _line2, _text3, _circle2, _line3, _text4, _circle3, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVa1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 418.96 369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-12{fill:#812990;}.cls-2,.cls-6{fill:#fff;}.cls-11,.cls-3{fill:none;stroke:#6b7b84;stroke-miterlimit:10;stroke-width:0.5px;}.cls-3{stroke-dasharray:2 2;}.cls-4{fill:#d5ddeb;}.cls-5{fill:url(#linear-gradient);}.cls-6{font-size:11.7px;font-family:ProximaNova-Bold, Proxima Nova;font-weight:700;}.cls-10,.cls-7{font-size:7.8px;font-weight:400;}.cls-10,.cls-12,.cls-7{font-family:ProximaNova-Regular, Proxima Nova;}.cls-8{letter-spacing:-0.03em;}.cls-9{letter-spacing:0em;}.cls-10{letter-spacing:-0.04em;}.cls-12{font-size:8px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 234.45,
    y1: 236.71,
    x2: 418.71,
    y2: 236.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d60f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#812990"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "197.58 368.74 234.43 313.46 50.18 313.46 50.18 368.74 197.58 368.74"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.15,358.1v.71H87v-4.06h3v.71h-2.2v1h1.84v.69H87.83v.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.52,354.47v4.34h-.81v-.19a1.82,1.82,0,0,1-.91.25,1.62,1.62,0,0,1,0-3.24,1.92,1.92,0,0,1,.91.23v-1.39Zm-.81,3.4v-1.26a1.19,1.19,0,0,0-.77-.26.89.89,0,0,0-.93.9.88.88,0,0,0,.93.89A1.16,1.16,0,0,0,93.71,357.87Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.86,355.68v3.13h-.8v-.2a1.55,1.55,0,0,1-.86.25c-.92,0-1.34-.43-1.34-1.44v-1.74h.8v1.74a.63.63,0,0,0,.69.72,1.08,1.08,0,0,0,.71-.25v-2.21Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103,358.23a1.5,1.5,0,0,1-1.21.63,1.62,1.62,0,1,1,0-3.23,1.51,1.51,0,0,1,1.22.62l-.52.48a.84.84,0,0,0-.7-.38.9.9,0,1,0,0,1.79.82.82,0,0,0,.7-.39Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.37,355.68v3.13h-.81v-.23a1.58,1.58,0,0,1-.91.28,1.62,1.62,0,0,1,0-3.24,1.76,1.76,0,0,1,.91.26v-.2Zm-.81.94a1.16,1.16,0,0,0-.77-.27.9.9,0,1,0,0,1.79,1.14,1.14,0,0,0,.77-.27Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.72,356.35v1.1c0,.56.1.72.5.72l.37,0v.59a1.74,1.74,0,0,1-.73.12.9.9,0,0,1-.94-1v-1.52h-.45v-.67h.45v-1.21h.8v1.21h.88v.67Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.73,354.88a.48.48,0,0,1,.46-.48.47.47,0,0,1,.46.48.46.46,0,0,1-.46.46A.47.47,0,0,1,111.73,354.88Zm.06.8h.81v3.13h-.81Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.27,357.25a1.72,1.72,0,1,1-1.72-1.62A1.67,1.67,0,0,1,117.27,357.25Zm-.79,0a.93.93,0,1,0-.93.89A.91.91,0,0,0,116.48,357.25Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.48,357.07v1.74h-.8v-1.74c0-.49-.24-.72-.69-.72a1,1,0,0,0-.69.24v2.22h-.8v-3.13h.8v.2a1.46,1.46,0,0,1,.84-.25C121.06,355.63,121.48,356.05,121.48,357.07Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.84,357a6.83,6.83,0,0,1-.62.93l.49.48-.48.44-.45-.44a1.81,1.81,0,0,1-1.08.44c-.94,0-1.54-.44-1.54-1.18a1.22,1.22,0,0,1,.85-1.09,1.09,1.09,0,0,1-.35-.79,1,1,0,0,1,1.14-1.1,1.06,1.06,0,0,1,1.16,1,1.25,1.25,0,0,1-.88,1.11l.7.66a3.54,3.54,0,0,0,.48-.67Zm-1.49,1-.9-.89c-.33.13-.49.33-.49.57s.28.56.77.56A.92.92,0,0,0,127.35,358Zm-1-2.14a.8.8,0,0,0,.35.58c.26-.08.61-.27.61-.59a.49.49,0,0,0-.49-.54A.51.51,0,0,0,126.33,355.83Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.52,354.75h.9l-1.9,4.06h-.38l-1.89-4.06h.89l1.19,2.65Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.43,354.88a.48.48,0,0,1,.47-.48.47.47,0,0,1,.45.48.46.46,0,0,1-.45.46A.47.47,0,0,1,137.43,354.88Zm.07.8h.8v3.13h-.8Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.83,358a2.62,2.62,0,0,0,1.08.25c.36,0,.51-.14.51-.3s-.18-.26-.66-.36c-.68-.15-1.17-.37-1.17-1s.47-.95,1.19-.95a3.16,3.16,0,0,1,1.23.25l-.27.59a2.76,2.76,0,0,0-1-.2c-.31,0-.47.1-.47.27s.2.26.7.36c.73.15,1.15.4,1.15,1s-.46,1-1.26,1a2.72,2.72,0,0,1-1.36-.3Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.51,355.68v3.13h-.8v-.23a1.59,1.59,0,0,1-.92.28,1.62,1.62,0,0,1,0-3.24,1.82,1.82,0,0,1,.92.26v-.2Zm-.8.94a1.18,1.18,0,0,0-.77-.27.9.9,0,1,0,0,1.79,1.18,1.18,0,0,0,.77-.27Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.54,357.62c0,.78-.63,1.25-1.58,1.25a3.19,3.19,0,0,1-1.69-.39l.3-.64a2.88,2.88,0,0,0,1.42.31c.44,0,.71-.16.71-.46s-.27-.4-.87-.54c-.83-.19-1.51-.42-1.51-1.23s.57-1.22,1.5-1.22a4,4,0,0,1,1.56.33l-.33.66a3.59,3.59,0,0,0-1.24-.27c-.42,0-.65.18-.65.44s.29.41.9.54C152.94,356.6,153.54,356.88,153.54,357.62Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.44,357.48a.86.86,0,0,0,.89.69,1,1,0,0,0,.81-.38l.52.42a1.72,1.72,0,0,1-1.42.65,1.62,1.62,0,0,1,0-3.23,1.5,1.5,0,0,1,1.53,1.67c0,.06,0,.12,0,.18Zm0-.52H157a.69.69,0,0,0-.76-.69A.83.83,0,0,0,155.44,357Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.8,356.12a1.18,1.18,0,0,1,1-.49.68.68,0,0,1,.19,0v.87a2.12,2.12,0,0,0-.38,0,.75.75,0,0,0-.8.82v1.51H159v-3.13h.81Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.28,355.68l-1.5,3.13h-.38l-1.51-3.13h.84l.86,1.78.85-1.78Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.34,354.88a.48.48,0,0,1,.47-.48.47.47,0,0,1,.45.48.46.46,0,0,1-.45.46A.47.47,0,0,1,166.34,354.88Zm.07.8h.8v3.13h-.8Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.39,358.23a1.52,1.52,0,0,1-1.22.63,1.62,1.62,0,1,1,0-3.23,1.52,1.52,0,0,1,1.23.62l-.52.48a.87.87,0,0,0-.71-.38.9.9,0,1,0,0,1.79.85.85,0,0,0,.71-.39Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.16,357.48a.87.87,0,0,0,.9.69,1,1,0,0,0,.8-.38l.52.42a1.72,1.72,0,0,1-1.42.65,1.62,1.62,0,0,1,0-3.23,1.5,1.5,0,0,1,1.53,1.67c0,.06,0,.12,0,.18Zm0-.52h1.55a.69.69,0,0,0-.76-.69A.81.81,0,0,0,173.17,357Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.84,358a2.61,2.61,0,0,0,1.07.25c.37,0,.52-.14.52-.3s-.18-.26-.67-.36c-.67-.15-1.16-.37-1.16-1s.47-.95,1.19-.95a3.16,3.16,0,0,1,1.23.25l-.27.59a2.76,2.76,0,0,0-1-.2c-.31,0-.47.1-.47.27s.19.26.7.36c.72.15,1.15.4,1.15,1s-.46,1-1.26,1a2.69,2.69,0,0,1-1.36-.3Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.33,323.79h-.77V326h-.45v-2.18h-.77v-.45h2Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.16,323.34V326h-.46v-1.86l-.86,1.34-.87-1.34V326h-.45v-2.63H177l.83,1.28.82-1.28Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107,330.16V331a6,6,0,0,0-1.49-.8,5.6,5.6,0,0,0-1.94-.32,5.81,5.81,0,0,0-2.27.43,5.42,5.42,0,0,0-1.79,1.2,5.56,5.56,0,0,0-1.19,1.78,5.68,5.68,0,0,0-.42,2.18,5.5,5.5,0,0,0,1.61,3.94,5.42,5.42,0,0,0,1.79,1.2,5.81,5.81,0,0,0,2.27.43h.22a6,6,0,0,0,2.28-.43v-3h0a3.14,3.14,0,0,1-1,.67,3.39,3.39,0,0,1-1.23.22,3,3,0,0,1-.52,0h0a3,3,0,0,1-1.76-.85,2.84,2.84,0,0,1-.93-2.14,2.88,2.88,0,0,1,.93-2.16,3.41,3.41,0,0,1,1-.66,3.49,3.49,0,0,1,1.24-.23,3.18,3.18,0,0,1,2.27.89,2.86,2.86,0,0,1,.94,2.16v5.57h2.68V330.16Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.64,341.05l-5.93-5.72v5.72H87V326h2.68v5.7L95.64,326h3.79L91.6,333.5l7.83,7.55Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.61,329.89a4.86,4.86,0,0,1,2,.39,4.42,4.42,0,0,1,1.53,1.08,4.76,4.76,0,0,1,1,1.6,5.48,5.48,0,0,1,.35,2v6.14h-2.68v-6.14a2.26,2.26,0,0,0-.78-1.76,2.54,2.54,0,0,0-1.83-.72,2.59,2.59,0,0,0-1.85.72,2.32,2.32,0,0,0-.76,1.76v6.14h-2.67V330.19h2.67v.8a5.38,5.38,0,0,1,1.36-.79A4.4,4.4,0,0,1,116.61,329.89Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.89,330.19a4.64,4.64,0,0,1,1.79-.32v2.54a3.18,3.18,0,0,0-2.27.89,2.94,2.94,0,0,0-.94,2.16v5.59H148.8V330.16h2.67V331A5.94,5.94,0,0,1,152.89,330.19Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160.74,329.89a6.07,6.07,0,0,1,2.3.43,5.88,5.88,0,0,1,1.87,1.2,5.45,5.45,0,0,1,1.26,1.78,5.2,5.2,0,0,1,.46,2.18,5.08,5.08,0,0,1-.46,2.16,5.45,5.45,0,0,1-1.26,1.78,5.88,5.88,0,0,1-1.87,1.2,6.37,6.37,0,0,1-4.6,0,6,6,0,0,1-1.87-1.2,5.45,5.45,0,0,1-1.26-1.78,5.08,5.08,0,0,1-.46-2.16,5.2,5.2,0,0,1,.46-2.18,5.45,5.45,0,0,1,1.26-1.78,6,6,0,0,1,1.87-1.2A6.07,6.07,0,0,1,160.74,329.89Zm0,2.54a3.18,3.18,0,0,0-2.27.89,2.86,2.86,0,0,0-.94,2.16,3.13,3.13,0,0,0,2,2.81,3.49,3.49,0,0,0,1.24.22,3.39,3.39,0,0,0,1.23-.22,3.29,3.29,0,0,0,1.05-.67,2.84,2.84,0,0,0,.93-2.14,2.88,2.88,0,0,0-.93-2.16A3.33,3.33,0,0,0,160.74,332.43Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.27,329.89a6,6,0,0,1,2.29.43,5.93,5.93,0,0,1,1.88,1.2,5.76,5.76,0,0,1,1.26,1.78,5.36,5.36,0,0,1,.46,2.18,5.23,5.23,0,0,1-.46,2.16,5.76,5.76,0,0,1-1.26,1.78,5.93,5.93,0,0,1-1.88,1.2,6.34,6.34,0,0,1-4.59,0,5.93,5.93,0,0,1-1.88-1.2,5.76,5.76,0,0,1-1.26-1.78,5.22,5.22,0,0,1-.45-2.16,5.35,5.35,0,0,1,.45-2.18,5.76,5.76,0,0,1,1.26-1.78,5.93,5.93,0,0,1,1.88-1.2A6,6,0,0,1,173.27,329.89Zm0,2.54a3.2,3.2,0,0,0-2.28.89,2.89,2.89,0,0,0-.94,2.16,3.11,3.11,0,0,0,2,2.81,3.41,3.41,0,0,0,1.24.22,3.3,3.3,0,0,0,1.22-.22,3.08,3.08,0,0,0,1-.67,2.82,2.82,0,0,0,.94-2.14,2.86,2.86,0,0,0-.94-2.16A3.28,3.28,0,0,0,173.27,332.43Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.64,330.16V331a5.94,5.94,0,0,0-1.5-.8,5.52,5.52,0,0,0-1.94-.32,5.8,5.8,0,0,0-2.26.43,5.44,5.44,0,0,0-3,3,5.68,5.68,0,0,0-.42,2.18,5.48,5.48,0,0,0,3.4,5.14,5.8,5.8,0,0,0,2.26.43h.23a6,6,0,0,0,2.28-.43v-3h0a3.08,3.08,0,0,1-1,.67,3.3,3.3,0,0,1-1.22.22,3,3,0,0,1-.52,0h0a2.92,2.92,0,0,1-.72-.18,3.11,3.11,0,0,1-2-2.81,2.89,2.89,0,0,1,.94-2.16,3.29,3.29,0,0,1,1-.66,3.41,3.41,0,0,1,1.24-.23,3.18,3.18,0,0,1,2.27.89,2.86,2.86,0,0,1,.94,2.16v5.57h2.68V330.16Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.66,330.16V331a6,6,0,0,0-1.49-.8,5.5,5.5,0,0,0-1-.25,7,7,0,0,0-1.15-.09,5.6,5.6,0,0,0-2.22.43,5.11,5.11,0,0,0-1.74,1.2,5.57,5.57,0,0,0-1.13,1.78,6.07,6.07,0,0,0-.4,2.18h0a5.52,5.52,0,0,0,3.4,5.14,5.85,5.85,0,0,0,2.27.43h.39a6,6,0,0,0,2.12-.43v-3h0a3.18,3.18,0,0,1-1,.67,3.39,3.39,0,0,1-1.23.22,3,3,0,0,1-.52,0h0a3.16,3.16,0,0,1-.72-.18,2.83,2.83,0,0,1-1-.67,2.87,2.87,0,0,1-.94-2.15,2.94,2.94,0,0,1,.22-1.12l0-.09a2.89,2.89,0,0,1,.68-.94,3.25,3.25,0,0,1,1-.66,3.49,3.49,0,0,1,1.24-.23,3.22,3.22,0,0,1,2.28.89,3,3,0,0,1,.68.94l0,.09a2.81,2.81,0,0,1,.22,1.13v4.24a2.86,2.86,0,0,1-.93,2.14,3.29,3.29,0,0,1-3.88.49l-1.94,1.82a5.87,5.87,0,0,0,1.65.85,6.13,6.13,0,0,0,1.89.29,6,6,0,0,0,4.17-1.65,5.45,5.45,0,0,0,1.26-1.78,5.14,5.14,0,0,0,.46-2.16v-9.56Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.14,350.26V351H87v-4.06h3v.72H87.83v1h1.83v.69H87.83v.91Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.27,346.59v4.33h-.8v-.19a1.82,1.82,0,0,1-.91.25A1.56,1.56,0,0,1,92,349.36a1.54,1.54,0,0,1,1.58-1.61,2,2,0,0,1,.91.23v-1.39Zm-.8,3.39v-1.25a1.2,1.2,0,0,0-.77-.27.9.9,0,0,0-.93.9.88.88,0,0,0,.93.89A1.16,1.16,0,0,0,94.47,350Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.38,347.81v3.12h-.8v-.21a1.53,1.53,0,0,1-.85.26c-.92,0-1.34-.43-1.34-1.44v-1.73h.8v1.73c0,.48.24.72.68.72a1,1,0,0,0,.71-.25v-2.2Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.3,350.35a1.53,1.53,0,0,1-1.21.63,1.62,1.62,0,1,1,0-3.23,1.51,1.51,0,0,1,1.22.62l-.52.48a.84.84,0,0,0-.7-.38.9.9,0,1,0,0,1.79.82.82,0,0,0,.7-.39Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.42,347.81v3.12h-.8v-.23a1.66,1.66,0,0,1-.91.28,1.62,1.62,0,0,1,0-3.23,1.85,1.85,0,0,1,.91.25v-.19Zm-.8.93a1.16,1.16,0,0,0-.77-.27.88.88,0,0,0-.92.89.89.89,0,0,0,.92.9,1.14,1.14,0,0,0,.77-.27Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.55,348.47v1.1c0,.56.1.72.5.72a3.7,3.7,0,0,0,.37,0v.6a2,2,0,0,1-.73.12.9.9,0,0,1-.94-1v-1.52h-.44v-.66h.44V346.6h.8v1.21h.88v.66Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.34,347.05a.46.46,0,1,1,.46.47A.46.46,0,0,1,116.34,347.05Zm.06.8h.8V351h-.8Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.64,349.37a1.71,1.71,0,1,1-1.71-1.62A1.66,1.66,0,0,1,122.64,349.37Zm-.79,0a.92.92,0,1,0-.92.89A.91.91,0,0,0,121.85,349.37Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.62,349.23V351h-.8v-1.75a.62.62,0,0,0-.68-.71,1,1,0,0,0-.69.24V351h-.8v-3.13h.8v.2a1.45,1.45,0,0,1,.83-.25C127.2,347.8,127.62,348.22,127.62,349.23Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.89,347.64v1.44h1.94v.71h-1.94V351h-.8v-4.06h3v.72Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.3,349.37a1.71,1.71,0,1,1-1.7-1.62A1.66,1.66,0,0,1,141.3,349.37Zm-.78,0a.92.92,0,1,0-.92.89A.91.91,0,0,0,140.52,349.37Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.27,347.81v3.12h-.8v-.21a1.53,1.53,0,0,1-.85.26c-.92,0-1.34-.43-1.34-1.44v-1.73h.8v1.73c0,.48.24.72.68.72a1.06,1.06,0,0,0,.71-.25v-2.2Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.39,349.23V351h-.8v-1.75c0-.48-.23-.71-.67-.71a1,1,0,0,0-.69.24V351h-.8v-3.13h.8v.2a1.43,1.43,0,0,1,.83-.25C151,347.8,151.39,348.22,151.39,349.23Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.67,346.59v4.33h-.8v-.19a1.85,1.85,0,0,1-.91.25,1.56,1.56,0,0,1-1.58-1.62,1.54,1.54,0,0,1,1.58-1.61,2,2,0,0,1,.91.23v-1.39Zm-.8,3.39v-1.25a1.2,1.2,0,0,0-.77-.27.9.9,0,0,0-.93.9.88.88,0,0,0,.93.89A1.16,1.16,0,0,0,155.87,350Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162,347.81v3.12h-.8v-.23a1.66,1.66,0,0,1-.91.28,1.62,1.62,0,0,1,0-3.23,1.88,1.88,0,0,1,.91.25v-.19Zm-.8.93a1.16,1.16,0,0,0-.77-.27.88.88,0,0,0-.92.89.89.89,0,0,0,.92.9,1.14,1.14,0,0,0,.77-.27Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.09,348.47v1.1c0,.56.1.72.5.72a3.7,3.7,0,0,0,.37,0v.6a2,2,0,0,1-.73.12.9.9,0,0,1-.94-1v-1.52h-.44v-.66h.44V346.6h.8v1.21H166v.66Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.88,347.05a.46.46,0,1,1,.46.47A.46.46,0,0,1,167.88,347.05Zm.06.8h.8V351h-.8Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.18,349.37a1.71,1.71,0,1,1-1.71-1.62A1.66,1.66,0,0,1,174.18,349.37Zm-.79,0a.92.92,0,1,0-.92.89A.91.91,0,0,0,173.39,349.37Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.16,349.23V351h-.8v-1.75a.62.62,0,0,0-.68-.71,1,1,0,0,0-.69.24V351h-.8v-3.13h.8v.2a1.45,1.45,0,0,1,.83-.25C178.74,347.8,179.16,348.22,179.16,349.23Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 87.05,
    y: 18.68,
    width: 294.8,
    height: 55.28
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "418.71 92.38 50.2 92.38 50.2 313.48 286.3 313.48 418.71 92.38"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "234.45 313.48 326.58 159.94 418.71 313.48 234.45 313.48"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(271.31 280.48)"
  }, "Sophiya Dulal", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 9.36
  }, "Masters in International "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 81.6,
    y: 9.36
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 86.12,
    y: 9.36
  }, "elations")), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18.72
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 6.58,
    y: 18.72
  }, "ebster University")))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 11.73,
    y1: 159.11,
    x2: 71.42,
    y2: 159.11
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(3.56 161.89)"
  }, "2")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 5.92,
    cy: 159.11,
    r: 5.67
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 11.73,
    y1: 345.01,
    x2: 71.42,
    y2: 345.01
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(4.56 347.79)"
  }, "1")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 5.92,
    cy: 345.01,
    r: 5.67
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 11.73,
    y1: 46.31,
    x2: 87.05,
    y2: 46.31
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(3.69 49.09)"
  }, "3")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 5.92,
    cy: 46.31,
    r: 5.67
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 50.2,
    y: 0.25,
    width: 368.5,
    height: 368.5,
    transform: "translate(468.91 369) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVa1);
export default __webpack_public_path__ + "static/media/va1.530f6e8bdafb168f7b297770c2017221.svg";
export { ForwardRef as ReactComponent };